import * as React from 'react';

import { ProductCarousel, ProductThumbnailLoader } from 'modules/catalogue/components';

export const NouveautesCatalogueLoader: React.FC = React.memo(() => (
    <ProductCarousel>
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
    </ProductCarousel>
));
